import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL } from '../constants';

const CMS_ASSETS_STATS_QUERY_KEY = 'cmsAssetsStatsQueryKey';

interface GetAssetsStatsResponse {
  totalViews: number;
  totalDownloads: number;
  totalCopies: number;
  totalShares: number;
  enterpriseId: string;
}

const getAssetsStats = (): Promise<GetAssetsStatsResponse> => FetchPromise.get(`${CMS_API_ROOT_URL}/assets/stats`);

export const useGetAssetsStats = () =>
  useQuery<GetAssetsStatsResponse, JQuery.jqXHR>({
    queryKey: [CMS_ASSETS_STATS_QUERY_KEY],
    queryFn: () => getAssetsStats(),
  });
